import { call, delay, put } from 'typed-redux-saga';
import {
  AsyncActionState,
  asyncActionStateMatchers,
  invoke,
  setupSlice,
} from '@owl-frontend/redux';
import notificationsApiClient from '../../api/notifications/client';
import type { Notification } from '../../api/notifications/interface';

export interface NotificationsState {
  notifications: Notification[];
  count: number;
  actions: {
    fetchNotifications: AsyncActionState<{
      notifications: Notification[];
      count: number;
    }>;
    setNotificationStatus: AsyncActionState<void>;
    pollNotifications: AsyncActionState<void>;
  };
}

export const initialState: NotificationsState = {
  notifications: [],
  count: 0,
  actions: {
    fetchNotifications: { status: 'uninitialized' },
    setNotificationStatus: { status: 'uninitialized' },
    pollNotifications: { status: 'uninitialized' },
  },
};

const POLL_INTERVAL_MS = 1 * 60_000; // 1 minute
function* pollNotifications(action) {
  while (true) {
    const response = yield* call(notificationsApiClient.fetch);
    yield put({
      type: 'notifications/fetchNotifications/fulfilled',
      payload: response,
      // forward action.meta
      meta: action.meta,
    });
    yield delay(POLL_INTERVAL_MS);
  }
}

const slice = setupSlice('notifications', initialState)
  .addAsyncSagas({
    fetchNotifications: invoke(notificationsApiClient.fetch),
    setNotificationStatus: invoke(notificationsApiClient.setStatus),
  })
  .addAsyncSagas(
    {
      pollNotifications,
    },
    {
      timeoutLimit: -1,
    }
  )
  .addReducers({
    'fetchNotifications/fulfilled': (state, action) => {
      state.notifications = action.payload.notifications;
      state.count = action.payload.count;
    },
  });

export const actions = slice.actions;
export default slice.addExtra(asyncActionStateMatchers(actions).all());
